import { createRouter, createWebHistory } from "vue-router";
import HomePage from "../views/HomePage.vue";
import AboutPage from "../views/AboutPage.vue";
import UppercaseConverter from "../views/UppercaseConverter.vue";
import LowercaseConverter from "../views/LowercaseConverter.vue"; // Adicionando a nova página
import SortText from "../views/SortText.vue"; // Adicionando a nova página
import RemoveDuplicates from "../views/RemoveDuplicates.vue"; // Adicionando a nova página
import GitCheatSheet from "../views/GitCheatSheet.vue"; // Adicionando a nova página
import LinuxCheatSheet from "../views/LinuxCheatSheet.vue"; // Adicionando a nova página
import SQLCheatSheet from "../views/SQLCheatSheet.vue"; // Adicionando a nova página
import MarkdownCheatSheet from "../views/MarkdownCheatSheet.vue"; // Adicionando a nova página
import QRCodeGenerator from "../views/QRCodeGenerator.vue"; // Adicionando a nova página
import FullYearCalendar from "../views/FullYearCalendar.vue"; // Adicionando a nova página





const routes = [
  { path: "/", name: "Home", component: HomePage },
  { path: "/about", name: "About", component: AboutPage },
  { path: "/uppercase", name: "UppercaseConverter", component: UppercaseConverter },
  { path: "/lowercase", name: "LowercaseConverter", component: LowercaseConverter },
  { path: "/remove-duplicates", name: "RemoveDuplicates", component: RemoveDuplicates },
  { path: "/sort", name: "SortText", component: SortText },
  { path: "/git-cheatsheet", name: "GitCheatSheet", component: GitCheatSheet },
  { path: "/linux-cheatsheet", name: "LinuxCheatSheet", component: LinuxCheatSheet },
  { path: "/sql-cheatsheet", name: "SQLCheatSheet", component: SQLCheatSheet },
  { path: "/markdown-cheatsheet", name: "MarkdownCheatSheet", component: MarkdownCheatSheet },
  { path: "/qrcode-generator", name: "QRCodeGenerator", component: QRCodeGenerator },
  { path: "/calendar", name: "FullYearCalendar", component: FullYearCalendar }
];

const router = createRouter({
  history: createWebHistory(),
  routes
});

export default router;
